<template>
  <v-dialog v-model="dialog" persistent max-width="480" content-class="comanda-modal">
    <v-card :key="key" class="comanda">
      <div class="comanda__encabezado">
        <v-icon color="white" class="mr-2">mdi-chef-hat</v-icon>
        <span class="comanda__titulo">{{ $t("print_remote") }}</span>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="$emit('close')" :title="$t('Cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pt-4">
        <p class="comanda__pregunta">{{ $t('select_print_remote') }}</p>

        <button type="button" class="comanda__opcion comanda__opcion--nueva" v-if="order && order.getTotalItemsPrintRemote() > 0"
          @click="printRemote(false)" :title="$t('print_remote_missing')">
          <v-icon color="primary" class="comanda__icono">mdi-printer-check</v-icon>
          <span class="comanda__texto">
            <strong>{{ $t("print_remote_missing") }}</strong>
            <small>{{ order.getTotalItemsPrintRemote() }} {{ order.getTotalItemsPrintRemote() === 1 ? "producto nuevo" : "productos nuevos" }} sin enviar a cocina</small>
          </span>
          <v-icon small>mdi-chevron-right</v-icon>
        </button>

        <button type="button" class="comanda__opcion" @click="printRemote(true)" :title="$t('print_remote_all')">
          <v-icon color="grey darken-1" class="comanda__icono">mdi-printer-search</v-icon>
          <span class="comanda__texto">
            <strong>{{ $t("print_remote_all") }}</strong>
            <small>Vuelve a imprimir todo el pedido ({{ order ? order.getItems(true).length : 0 }} líneas)</small>
          </span>
          <v-icon small>mdi-chevron-right</v-icon>
        </button>

        <p class="comanda__nota">
          <v-icon x-small>mdi-lock-outline</v-icon>
          Al imprimir, el pedido se guarda y lo impreso queda protegido: cambiarlo o quitarlo después pide un motivo.
        </p>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="px-4 py-3">
        <v-spacer></v-spacer>
        <v-btn text large @click="$emit('close')">{{ $t("Cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style>
.comanda__encabezado {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 8px 0 16px;
  color: #fff;
  background: var(--pos-encabezado);
}

.comanda__titulo {
  font-size: 1.2rem;
  font-weight: 500;
}

.comanda__pregunta {
  margin: 0 0 12px;
  font-weight: 500;
}

.comanda__opcion {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 10px;
  padding: 12px 14px;
  border: 1.5px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.comanda__opcion:hover {
  border-color: var(--v-primary-base);
}

.comanda__opcion--nueva {
  border-color: var(--v-primary-base);
  background: rgba(36, 169, 225, 0.06);
}

.comanda__texto {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.3;
}

.comanda__texto small {
  color: rgba(0, 0, 0, 0.6);
}

.comanda__nota {
  margin: 4px 0 0;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
}
</style>
<script>
import NgTextKeyboard from '../../../gui/NgTextKeyboard.vue';
const DEFAULT_ITEM = { reason: "" };
export default {
  components: { NgTextKeyboard },
  name: "CartPrintRemote",
  data: () => ({
    searched: false,
    key: 0,
    tip: 0,
    automatic: true
  }),
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    order: Object 
  },
  watch: {
    "$store.getters.orderChanged": function () {
      this.tip = this.$pos.getCurrentOrder().getPriceTip(); 
    }
  },
  mounted() {
    this.tip = this.$pos.getCurrentOrder().getPriceTip();
  },
  methods: {
    cancel() {
      this.clear();
      this.searched = false;
      this.key++;
      this.$emit("cancel");
    },
    clear() {
      this.item = JSON.parse(JSON.stringify(DEFAULT_ITEM));
    },
    // La comanda se guarda en el servidor antes de imprimirse: lo que sale a cocina siempre queda registrado,
    // y las líneas impresas ya no se cambian sin un motivo. Sin internet la cocina no se queda sin comanda:
    // se imprime igual y se avisa que el pedido no quedó guardado.
    async printRemote(all) {
      const orden = this.order;
      // A cocina solo se manda lo que aún no está allá: un pedido en preparación no vuelve a «recibido».
      if (!["preparing", "prepared"].includes(orden.order_status)) {
        this.$pos.setOrderStatus(orden, "received");
      }
      if (this.$store.getters.online) {
        let res = null;
        try {
          res = await this.$pos.saveOrder(orden, this.$http);
        } catch (e) {
          res = null;
        }
        if (!res || !res.success) {
          this.$store.commit("setMessage", "No se pudo guardar el pedido, así que no se imprimió la comanda. Revisa la conexión e inténtalo de nuevo.");
          return;
        }
      } else {
        this.$store.commit("setMessage", "Sin conexión: la comanda se imprimió, pero el pedido no quedó guardado. Se guardará al cobrar.");
      }
      this.$emit("cancel");
      this.$pos.printRemote(orden, all);
    }
  },
};
</script>